import { styled } from '@mui/material/styles';
import { Input } from '@components/Input';
import Button from '@components/Button';
import { Typography } from '@components/Typography';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MoveIcon } from 'assets/images/icons';
import { useTranslation } from '@hooks';

const Form = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
    gridGap: 16,
    margin: '8px 0',
    paddingTop: 8,
    '@media (max-width: 1200px)': {
        gridTemplateColumns: '100%',
    },
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
    },
});

const QuestionWrapper = styled('div', {
    shouldForwardProp: prop => prop !== 'isExpanded',
})(({ isExpanded }) => ({
    padding: isExpanded ? '4px 16px 16px' : '4px 16px',
    marginBottom: 8,
    cursor: 'pointer',
    backgroundColor: '#fff',
    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    borderRadius: 4,
    position: 'relative',
}));

const QuestionItem = ({
    listeners,
    attributes,
    isView,
    index,
    question,
    isOpen,
    onClick,
    onChange,
    onDelete,
    setLocalizeModal,
}) => {
    const { t } = useTranslation();

    return (
        <QuestionWrapper isExpanded={isOpen}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 15,
                    left: 0,
                }}
                onClick={() => onClick(+index)}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                    }}
                >
                    <span {...listeners} {...attributes} style={{ cursor: 'grab' }}>
                        <MoveIcon />
                    </span>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                        <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.6)', margin: '4px 0 8px' }}>
                            {question?.title}
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: '500 !important' }}>
                            {question?.question}
                        </Typography>
                    </div>
                </div>
                {isOpen ? (
                    <ExpandLessIcon className="sidebar-menu-arrow" />
                ) : (
                    <ExpandMoreIcon className="sidebar-menu-arrow" />
                )}
            </div>
            {isOpen ? (
                <>
                    <Form>
                        <Input
                            inputProps={{
                                name: 'title',
                                value: question?.title,
                                onChange: e => onChange(e, index, question?.language),
                            }}
                            label={t('common.title')}
                            error={!question?.title}
                            helperText={!question?.title ? t('validation.required') : ''}
                            fullWidth
                            required
                            disabled={isView}
                        />
                        <Input
                            inputProps={{
                                name: 'question',
                                value: question?.question,
                                onChange: e => onChange(e, index, question?.language),
                            }}
                            label={t('common.question')}
                            error={!question?.question}
                            helperText={!question?.question ? t('validation.required') : ''}
                            fullWidth
                            disabled={isView}
                        />
                    </Form>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => setLocalizeModal({ open: true, index })}
                            disabled={isView}
                        >
                            {t('buttons.localization')}
                        </Button>
                        <div>
                            <Button variant="danger" size="large" onClick={() => onDelete(index)} disabled={isView}>
                                {t('buttons.delete')}
                            </Button>
                        </div>
                    </div>
                </>
            ) : null}
        </QuestionWrapper>
    );
};

export default QuestionItem;
